import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { VisualizzaPAFilterComponent } from './visualizza-pa-filter';

export const VisualizzaPAFilterModule: string = ng
    .module('visualizza-pa-filter', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('visualizzaPAFilterComponent', VisualizzaPAFilterComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/visualizza-pa-filter/visualizza-pa-filter.module.ts